module.exports = __webpack_public_path__ + "img/login-logo.396bea34.png";